import ReleaseNotes from '@src/main/modules/parameters/ui/release-notes/components/ReleaseNotes';

const ReleaseNotesPage = () => <ReleaseNotes />;

export default ReleaseNotesPage;
